import { MenuItem } from '@mui/material';
import { CustomSelect, CustomTextField, HeaderFilterBox } from '../../../common';

const CouponsFilters = ({ filter, handleFilter, plans, groups }) => {
  const generateMenuItems = () => {
    const currentYear = new Date().getFullYear();
    const startYear = 1990;
    let items = [];

    for (let i = currentYear; i >= startYear; i--) {
      items.push(
        <MenuItem key={i} value={i}>
          {i}
        </MenuItem>
      );
    }

    return items;
  };

  const filterStyles = {
    ml: { xs: 0, md: 2 },
    mt: 0,
    width: { xs: '100%', sm: '48%', md: '15%' },
    mb: { xs: 1, md: 0 },
  };

  return (
    <HeaderFilterBox>
      <CustomSelect
        label="Trimestre"
        labelId="quarter-label"
        id="quarter-select"
        name="quarter"
        value={filter.quarter}
        onChange={handleFilter}
        displayEmpty
        sx={filterStyles}
        size="medium"
      >
        <MenuItem value="">Todos</MenuItem>
        <MenuItem value={1}>1 (Ene, Feb, Mar)</MenuItem>
        <MenuItem value={2}>2 (Abr, May, Jun)</MenuItem>
        <MenuItem value={3}>3 (Jul, Ago, Sep)</MenuItem>
        <MenuItem value={4}>4 (Oct, Nov, Dic)</MenuItem>
      </CustomSelect>

      <CustomSelect
        label="Año"
        labelId="year-label"
        id="year-select"
        name="year"
        value={filter.year}
        onChange={handleFilter}
        sx={filterStyles}
        size="medium"
        MenuProps={{
          PaperProps: {
            style: {
              maxHeight: '300px',
              overflow: 'auto',
            },
          },
        }}
      >
        {generateMenuItems()}
      </CustomSelect>

      <CustomSelect
        label="Plan"
        labelId="plan-label"
        id="plan-select"
        name="plan"
        value={filter.plan || (plans.length > 0 ? plans[0].uuid : '')}
        onChange={handleFilter}
        sx={filterStyles}
        size="medium"
      >
        {plans.map((plan) => (
          <MenuItem key={plan.uuid} value={plan.uuid}>
            {plan.name}
          </MenuItem>
        ))}
      </CustomSelect>

      <CustomSelect
        label="Grupo"
        labelId="group-label"
        id="group-select"
        name="group"
        value={filter.group}
        onChange={handleFilter}
        displayEmpty
        sx={filterStyles}
        size="medium"
      >
        <MenuItem value="">Todos</MenuItem>
        {groups.map((group) => (
          <MenuItem key={group.uuid} value={group.uuid}>
            {group.name}
          </MenuItem>
        ))}
      </CustomSelect>

      <CustomTextField
        label="Orden"
        id="order-input"
        name="contract_number"
        value={filter.contract_number}
        onChange={handleFilter}
        sx={{
          ml: { xs: 0, md: 2 },
          mt: 0,
          width: { xs: '100%', sm: '48%', md: '15%' },
        }}
        size="medium"
      />
    </HeaderFilterBox>
  );
};

export default CouponsFilters;
